/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Log_StartInputs */

const en_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting sync process`)
};

const fr_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage du processus de synchronisation`)
};

const de_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierungsprozess wird gestartet`)
};

const it_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del processo di sincronizzazione`)
};

const ru_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск процесса синхронизации`)
};

const es_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando el proceso de sincronización`)
};

const zh_cn2_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始同步过程`)
};

const ja_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期プロセスを開始しています`)
};

const hi_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़ेशन प्रक्रिया शुरू हो रही है`)
};

const pt_pt2_sync_changes_log_start = /** @type {(inputs: Sync_Changes_Log_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando o processo de sincronização`)
};

/**
* | output |
* | --- |
* | "Starting sync process" |
*
* @param {Sync_Changes_Log_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_log_start = /** @type {((inputs?: Sync_Changes_Log_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Log_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_log_start(inputs)
	if (locale === "de") return de_sync_changes_log_start(inputs)
	if (locale === "it") return it_sync_changes_log_start(inputs)
	if (locale === "ru") return ru_sync_changes_log_start(inputs)
	if (locale === "es") return es_sync_changes_log_start(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_log_start(inputs)
	if (locale === "ja") return ja_sync_changes_log_start(inputs)
	if (locale === "hi") return hi_sync_changes_log_start(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_log_start(inputs)
	return en_sync_changes_log_start(inputs)
});